/* eslint-disable react/jsx-props-no-spreading */
import { Layer } from 'grommet';
import { ReactNode, useEffect, useState } from 'preact/compat';

import withDefaults from '../withDefaults';
import backgroundImage from './assets/background.svg';

interface MembersOnlyWarningModalProps {
  profilePicture: string;
  children: ReactNode;
  onClickOutside?: () => void;
}

const MembersOnlyWarningModal = ({ profilePicture, children, onClickOutside }: MembersOnlyWarningModalProps) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          setIsMobile(document.body.classList.contains('group/mobile-layout'));
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    // Initial check
    setIsMobile(document.body.classList.contains('group/mobile-layout'));

    // Cleanup
    return () => observer.disconnect();
  }, []);

  return (
    <Layer
      full={isMobile ? 'horizontal' : undefined}
      animation={isMobile ? 'slide' : 'fadeIn'}
      position={isMobile ? 'bottom' : undefined}
      className="!overflow-auto !rounded-t-2xl mobile:!max-w-full desktop:!w-[calc(100%-3rem)] desktop:!max-w-[406px] desktop:!rounded-b-2xl"
      onEsc={onClickOutside}
      onClickOutside={onClickOutside}
    >
      <div className="flex flex-col justify-center rounded-t-2xl desktop:rounded-b-2xl">
        <div className="p-6">
          <div
            style={{ backgroundImage: `url(${backgroundImage})` }}
            className="flex justify-center bg-contain bg-center bg-no-repeat"
          >
            <img
              alt="join zoolife"
              src={profilePicture}
              className="preflight preflight-img w-2/3 max-w-[268px] rounded-full"
            />
          </div>
        </div>
        <div className="flex flex-col gap-6 px-6">{children}</div>
      </div>
    </Layer>
  );
};

MembersOnlyWarningModal.Title = withDefaults('h3', {
  className: 'preflight preflight-h3 mb-2 text-center text-2xl font-bold text-black',
});

MembersOnlyWarningModal.Content = withDefaults('p', {
  className: 'preflight preflight-p text-center text-base font-light text-grey-6',
});

MembersOnlyWarningModal.ButtonsContainer = withDefaults('div', {
  className: 'flex flex-col gap-2 pb-3',
});

export default MembersOnlyWarningModal;
